import { faPaperclipVertical } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import DocumentsTable from "@mirage/components/documentsTable/DocumentsTable";
import Badge from "@mui/material/Badge";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import { PublicPortalTheme } from "@publicPortal/theme/MuiPublicPortal.module";
import { useState } from "react";
import "./CommentCard.css";

const CommentCard = (commentCard: ICommentCard) => {
    const [showAttachments, setShowAttachments] = useState(false);
    const [actionButtonHover, setActionButtonHover] = useState(false);
    const entityName = commentCard.attachments?.entityName || "";
    const recordId = commentCard.attachments?.commentId || 0;
    const attachmentsCounter = commentCard.attachments?.attachmentsCounter || 0;
    const cardContent = commentCard.cardContent || "";

    return (
        <Card className="commentCard">
            <CardHeader
                title={getCommentTitle()}
                subheader={commentCard.subheader}
                className="commentCard__header"
                action={
                    <IconButton
                        onMouseEnter={() => setActionButtonHover(true)}
                        onMouseLeave={() => setActionButtonHover(false)}
                        aria-label="Show attachments for a comment"
                        onClick={() => setShowAttachments(!showAttachments)}
                    >
                        <Badge badgeContent={attachmentsCounter} color="primary">
                            <FontAwesomeIcon className={iconClassName()} icon={faPaperclipVertical} style={PublicPortalTheme.icons.sizeM} />
                        </Badge>
                    </IconButton>
                }
            />
            {getAttachmentsTable()}
            <CardContent>
                <Typography variant="cardContent">{cardContent}</Typography>
            </CardContent>
        </Card>
    );

    function getAttachmentsTable() {
        if (showAttachments) {
            return (
                <div className="commentCard__attachmentsContainer">
                    <DocumentsTable
                        publicOnly={false}
                        displayFor={{ entityRecord: { entityName: entityName, recordId: recordId } }}
                        stateKey={`attachments-comment-${commentCard.commentKey}`}
                    />
                </div>
            );
        }
        return null;
    }

    function getCommentTitle() {
        const cardTitle = commentCard.cardTitle || "";
        const cardTitleCaption = commentCard.cardTitleCaption || "";

        return (
            <>
                <b>{cardTitle}</b>
                <Typography variant="caption">{cardTitleCaption}</Typography>
            </>
        );
    }

    function iconClassName() {
        if (showAttachments && actionButtonHover) {
            return "commentCard__icon commentCard__icon--straight";
        } else if (showAttachments || actionButtonHover) {
            return "commentCard__icon commentCard__icon--lean";
        }
        return "commentCard__icon commentCard__icon--straight";
    }
};

interface ICommentCard {
    commentKey: string;
    cardTitle: string;
    cardContent: string | null | undefined;
    cardTitleCaption?: string | null | undefined;
    subheader?: string;
    attachments?: {
        attachmentsCounter: number;
        commentId: number;
        entityName: string;
    };
}

export default CommentCard;
export type { ICommentCard };
